//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default BaseCmsBlock.extend({
  name: "ProductLicensesBlock",
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    isUserAuth() {
      return this.$store.getters['user/isLoggedIn'];
    },
    licenseList() {
      const licenses = [];
      const items = [...this.extras.items];

      const licenseMap = new Map();
      items.forEach(item => {
        licenseMap.set(item?.license?.id, {
          ...item?.license,
          count: item?.license_items_count
        });
      });

      const values = [...this.values.products];
      values.forEach(t => {
        const license = licenseMap.get(t.license);
        if (license) {
          licenses.push({...t, price: license, count: license?.count || 0});
        }
      });

      return licenses;
    }
  },
  methods: {
    async onBuyLicense(product) {
      this.isLoading = true;

      if (!this.isUserAuth) {
        await this.$router.push(this.localePath("/registration?goback=1"));
        return
      }

      const balance = await this.checkUserBalance(product?.price?.price);
      if (!balance) {
        return;
      }

      const res = await this.$api.agent.transport(`license/get/${product?.price?.id}`)
        .catch((err) => ({error: errorParseNetwork(err.response)}));

      if (res.error) {
        this.isLoading = false;
        this.$toast.error(res.error);

        return;
      }
      this.$root.$emit('getBalance');
      this.$toast.success(this.$t('license.licenseSuccess'));
      this.isLoading = false;
    },

    async checkUserBalance(currentPrice) {
      // Проверка баланса пользователя
      const balance = await this.$api.agent.transport.get("sms-users/balance")
        .then((res) => {
          return res.data
        }).catch(() => {
          return 0
        });

      if (balance < +currentPrice) {
        await this.$router.push(this.localePath("/profile/pay"));
        return false;
      }

      return true;
    }
  },

})
